import { useEffect, useRef, useState } from "react";
import { Character, characters } from "./characters";
import spriteUrl from "./homm3-sprite.png";

const getCharacter = (char: string): Character => {
  if ("sameAs" in characters[char]!)
    return getCharacter(characters[char].sameAs);

  return characters[char]!;
};

const img = new Image();
img.src = spriteUrl;

export const Text = ({
  value,
  scale = 1,
}: {
  value: string;
  scale?: number;
  maxWidth?: number;
}) => {
  const [loaded, setLoaded] = useState(false);
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    window.devicePixelRatio
  );
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (img.complete) {
      setLoaded(true);
    } else {
      img.addEventListener("load", () => {
        return setLoaded(true);
      });
    }

    const onResize = () => {
      setDevicePixelRatio(window.devicePixelRatio);
    };

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const chars = value.split("");
  let width = 0;
  let height = 0;

  for (const char of chars) {
    const data = getCharacter(char);

    width += data.width;
    height = Math.max(height, 10 + (data.translateY ?? 0));
  }
  const canvas = canvasRef.current;

  const rect = { width, height };

  if (canvas) {
    const ctx = canvas?.getContext("2d")!;
    // ctx.imageSmoothingEnabled = false;

    canvas.width = rect.width * scale;
    canvas.height = rect.height * scale;

    // // Set the "drawn" size of the canvas
    canvas.style.width = `${rect.width * scale}px`;
    canvas.style.height = `${rect.height * scale}px`;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = false;

    const currentOffset = { x: 0, y: 0 };

    for (const char of chars) {
      const data = getCharacter(char);

      if (
        data.height !== undefined &&
        data.x !== undefined &&
        data.y !== undefined
      ) {
        const yOffset = 10 - (data.height ?? 0) + (data.translateY ?? 0);
        ctx.drawImage(
          img,
          data.x,
          data.y,
          data.width,
          data.height,
          currentOffset.x * scale,
          yOffset * scale,
          data.width * scale,
          data.height * scale
        );
      }

      currentOffset.x += data.width;
    }
  }

  const deviceScaler = Math.round(devicePixelRatio) / devicePixelRatio;

  return (
    <div
      style={{
        height: 10 * scale * deviceScaler,
        width: rect.width * scale * deviceScaler,
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          imageRendering: "pixelated",
          transform: `scale(${deviceScaler})`,
          transformOrigin: "left top",
        }}
      />
    </div>
  );
};
